










































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import FilterToggle from '@/components/FilterToggle.vue'
import {ListNotasInseridasSchema} from '@/schema/resource/NotasInseridas/ListNotasInseridasSchema'
import moment from 'moment'
import {NotasInseridasFilterCollection} from '@/model/filter/NotasInseridasFilterCollection'
import {NotasInseridas} from '@/model/resource/NotasInseridas'
import {QtdNotasMes} from '@/model/resource/QtdNotasMes'
import NotasInseridasFilter from '@/components/filters/NotasInseridasFilter.vue'
import {NotasInseridasCollection} from '@/model/collection/NotasInseridasCollection'
import {CsvNotasInseridasSchema} from '@/schema/resource/NotasInseridas/CsvNotasInseridasSchema'

@Component({
  components: {NotasInseridasFilter, FilterToggle},
})
export default class ListNotasInseridasMonthlyView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListNotasInseridasSchema()
  collection = new NotasInseridasFilterCollection()
  filterOpen = false

  months: string[] = []

  table: number[] = []

  date = ''

  async created() {
    await this.lastGenerationDate()
    this.collection.asc = false
    this.collection.monthly = true
    this.collection.ano = moment().year()

    this.buildMonthsHeader()

    await this.collection.queryAsPage()
  }

  buildMonthsHeader() {
    this.months = moment.months()
  }

  buildMonthlyData(list: QtdNotasMes[]) {
    const table = Array<number | null>(12).fill(null)
    list.forEach(item => {
      if (item && item.mes) {
        table[item.mes - 1] = item.qtdNota || 0
      }
    })
    return table
  }

  async lastGenerationDate() {
    await this.$await.run('getLastUpdate', async () => {
      this.date = Helper.datetime(await NotasInseridas.getLastGenerationDate())
    })
  }

  async downloadXlsx() {
    const {ascending, orderBy, page, limit, ...params} = this.collection.params
    const collection = new NotasInseridasCollection()
      .clearFilters()
      .addFilter(params)
    await collection.listNotasInseridasMonthlyCsv()
    this.$xlsx.downloadFromSchema(
      collection.all(),
      new CsvNotasInseridasSchema(collection.populatedMounts),
      this.$t('schema.CsvNotasInseridas.titleCsvMensal') as string
    )
  }
}
